<div [formGroup]="formValidationGroup">
  <app-xpath [disabled]="isAlwaysEditable ? false : !isEditable" [(value)]="datafield.Value" (valueChange)="valueChange()">
  </app-xpath>
  @if (!isValid) {
  <div class="error">{{ errorText }}</div>
  }
</div>
